import { createContext } from "react";

const InspectorEnCampoContext = createContext();

export default InspectorEnCampoContext;